import {
  SET_SEGMENT_DETAIL,
  START_SEGMENT_TRACKING,
  FINISH_SEGMENT_TRACKING,
} from './actions';
import { trackAction } from '../../../native/bridge/SegmentAnalyticHelper';
import { NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS } from '../../../web/client-data/site-data';
import { selectCurrentUserEducatorSubscription } from '../../UserSubscriptionPlans/selectors';

export function setSegmentDetails(eventName, segmentDetails) {
  return (dispatch) => {
    dispatch({
      eventName,
      segmentDetails,
      type: SET_SEGMENT_DETAIL,
    });
  };
}

export function trackUserAction() {
  return (dispatch, getState) => {
    dispatch({ type: START_SEGMENT_TRACKING });
    const userEducatorSubscriptionPlan = selectCurrentUserEducatorSubscription(
      getState()
    );
    let options = {};
    if (!userEducatorSubscriptionPlan) {
      options = {
        ...NO_EDUCATOR_SUBSCRIPTION_INTEGRATIONS,
      };
    }

    trackAction(
      getState().Segment.get('eventName'),
      getState()
        .Segment.get('segmentDetails')
        .toJS(),
      {
        integrations: options,
      }
    );
    dispatch({ type: FINISH_SEGMENT_TRACKING });
  };
}
